
const agent = {
  createNew: {
    newReservation: 'Nueva reserva',
    quickReservation: 'Reserva rápida',
  },

  searchBox: {
    searchBtn: 'Buscar',
  },

  table: {
    myLastBookingsTable: {
      title: 'Mis últimas reservas',
      headers: {
        id: 'ID',
        date: 'Fecha',
        status: 'Estado',
        passenger: 'Pasajero',
      },
    },
    myRecentViewsTable: {
      title: 'Mis visualizaciones recientes',
      headers: {
        id: 'ID',
        date: 'Fecha',
        status: 'Estado',
        passenger: 'Pasajero',
      },
    },
  },

  statistics: {
    lastWeek: {
      title: 'Semana anterior',
    },
    last24Hours: {
      title: 'Últimas 24 horas',
    },
    myLastWeek: {
      title: 'Mi semana anterior',
    },
    myLast24Hours: {
      title: 'Mis últimas 24 horas',
    },
  },

  weatherInfo: {
    title: 'Tiempo',
    noNewMessages: 'No hay nuevos mensajes',
    loadingWeather: 'Cargando tiempo ...',
  },

  radioButton: {
    showTen: '10',
    showFive: '5',
  },
};

export default agent;
